import antdPl from "antd/lib/locale/pl_PL";
import appLocaleData from "react-intl/locale-data/pl";
import plMessages from "../locales/pl.json";
// Keys not in POEditor yet. The deploy overwrites pl.json from POEditor, so
// new keys live here until they are added there; POEditor values win.
import pendingPl from "../locales/pending/pl.json";
import 'moment/locale/pl';

const PlLang = {
  messages: {
    ...pendingPl,
    ...plMessages
  },
  antd: antdPl,
  locale: 'pl',
  data: appLocaleData
};
export default PlLang;
